<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">CONTENTS</h1>
<div class="SOM_pre"><a href="#/pre2">G<span class="small">ENERAL</span> I<span class="small">NTRODUCTION</span></a></div>
<div class="SOM_pre"><a href="#/pre3">V<span class="small">OLUME</span> E<span class="small">DITOR</span>’<span class="small">S</span> I<span class="small">NTRODUCTION</span></a></div>
<div class="SOM_pre"><a href="#/pre4">E<span class="small">XPOSITION</span> <span class="small">OF</span> <span class="small">THE</span> B<span class="small">OOK</span> <span class="small">OF</span> J<span class="small">OB</span></a></div>
<div class="SOM_part"><span href="#/p1chap1" title="Link target outside of Sample">TRACTATES ON THE PROPHETS HOSEA, JOEL, AND AMOS</span></div>
<div class="SOM_chap"><span href="#/p1chap1" title="Link target outside of Sample">C<span class="small">OMMENTARY</span> <span class="small">ON</span> <span class="small">THE</span> P<span class="small">ROPHET</span> H<span class="small">OSEA</span></span></div>
<div class="SOM_chap"><span href="#/p1chap2" title="Link target outside of Sample">C<span class="small">OMMENTARY</span> <span class="small">ON</span> <span class="small">THE</span> P<span class="small">ROPHET</span> J<span class="small">OEL</span></span></div>
<div class="SOM_chap"><span href="#/p1chap3" title="Link target outside of Sample">C<span class="small">OMMENTARY</span> <span class="small">ON</span> <span class="small">THE</span> P<span class="small">ROPHET</span> A<span class="small">MOS</span></span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">B<span class="small">IBLIOGRAPHY</span></span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">G<span class="small">ENERAL</span> I<span class="small">NDEX</span></span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">S<span class="small">CRIPTURE</span> I<span class="small">NDEX</span></span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">N<span class="small">OTES</span></span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">A<span class="small">BOUT</span> <span class="small">THE</span> A<span class="small">UTHOR</span></span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">M<span class="small">ORE</span> T<span class="small">ITLES</span> <span class="small">FROM</span> I<span class="small">NTER</span>V<span class="small">ARSITY</span> P<span class="small">RESS</span></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?513a83ce